// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8r5Pn","col":"styles_col__3IEUH"};